// Module
var code = "<v-footer height=\"auto\" fixed class=\"footer-class\">\n  <cs-dashboard v-if=\"footer.dashboard\" :dashboard=\"footer.dashboard\"></cs-dashboard>\n</v-footer>\n";
// Exports
module.exports = code;